import { Errors } from '@/constants/errors';
import { paymentMethodRequireBank, StripeParamsByPaymentMethod } from '@/constants/stripe';
import { stripeService } from '@/services/stripe';
import { PaymentMethodEnum } from '@/types/common';
import type { ICheckoutContext } from '@/types/context';
import { buildStripeGenericPaymentRequest } from '@/utils/stripe';
import { type CreatePaymentMethodData, type StripeElements } from '@stripe/stripe-js';

export const handleGenericStripePayment = async (
  checkout: ICheckoutContext,
  sendPaymentToServer: <TResponse>(params: unknown) => Promise<TResponse>,
  params: Record<string, string>
): Promise<unknown> => {
  try {
    const selectedPaymentMethod =
      checkout.paymentMethodSelected === PaymentMethodEnum.OTHER
        ? checkout.otherMethodSelected
        : checkout.paymentMethodSelected;
    const paymentMethodSettings = checkout.paymentMethodsSettings.find(
      (pm) => pm.paymentMethodName === selectedPaymentMethod
    );

    if (!paymentMethodSettings || !selectedPaymentMethod) {
      throw new Error(Errors.payment.paymentFailed);
    }

    const defaultStripeParams = {
      email: params.email ?? checkout.customer.email ?? '',
    };

    let stripePaymentMethod;

    if (paymentMethodRequireBank.includes(selectedPaymentMethod)) {
      stripePaymentMethod = await stripeService.createGenericBankRequiredPaymentMethod({
        ...(StripeParamsByPaymentMethod[selectedPaymentMethod]?.({
          ...defaultStripeParams,
          ...params,
          email: checkout.customer.email ?? '',
        }) as CreatePaymentMethodData & { elements: StripeElements }),
      });
    } else {
      stripePaymentMethod = await stripeService.createGenegicStripePaymentMethod(
        StripeParamsByPaymentMethod[selectedPaymentMethod]?.({ ...defaultStripeParams, ...params }) ??
          ({} as CreatePaymentMethodData)
      );
    }

    return await sendPaymentToServer(
      buildStripeGenericPaymentRequest(stripePaymentMethod, paymentMethodSettings, checkout.customer)
    );
  } catch (error) {
    console.error(Errors.payment.paymentFailed, { cause: error });
  }
};
